import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	gadgetLimitFlagTitle: {
		id: 'dashboard-edit.utils.add-gadget-within-limit.gadget-limit-flag-title',
		defaultMessage: 'Error.',
		description:
			'Text in notification flag to alert user that they have reached max number of gadgets they can have on a dashboard',
	},
	gadgetLimitFlagDescription: {
		id: 'dashboard-edit.utils.add-gadget-within-limit.gadget-limit-flag-description',
		defaultMessage:
			'Sorry, you have exceeded the maximum number of gadgets supported by your dashboard.  You must remove some gadgets before proceeding.',
		description:
			'Text in notification flag to alert user that they have reached max number of gadgets they can have on a dashboard',
	},
});
